import React from 'react';

import { DetailComponent } from '../../shared/detail';

export const ManagementDetail = () => <DetailComponent />;
